<template>
  <section :class="[alignment, 'heading-panel mt-md-4 d-flex flex-column w-100 text-white']">
    <div class="d-flex align-items-center gap-2">
     <i v-if="icon" :class="icon" class="fs-4 ms-2 mb-2"></i>
     <h1 class="heading-panel__title">{{ title }}</h1>
    </div>
    <span class="heading-panel__subtitle"
     v-html="subtitle">
    </span>
  </section>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: null,
  },
  alignment: {
    type: String,
    default: 'align-items-start',
  },
});

</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/abstracts/mixins";
.heading-panel {
  padding: 1rem 2rem;
  border-radius: $border-radius-default;
  background: $color-gradient-primary;
  box-shadow: $box-shadow-blur;

  &__icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  &__title {
    font-size: 2.5rem;
    font-weight: 600;
  }
  &__subtitle {
    font-size: 1.4rem;
    font-weight: 400;
  }
  @include respond(xl) {
    &__title {
      font-size: 2rem;
    }

    &__icon {
      width: 24px;
      height: 24px;
    }

    &__subtitle {
      font-size: 1.2rem;
    }
  }
  @include respond(md) {
    &__title {
      font-size: 1.6rem;
    }

    &__icon {
      width: 20px;
      height: 20px;
    }

    &__subtitle {
      font-size: 1rem;
    }
  }
}
</style>